import axios, { AxiosInstance } from 'axios';
import uiConfig from './Config';
import { getPersonalisationKey } from './Personalisation';

const ajax: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: uiConfig.api,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'X-Requested-With': 'XMLHttpRequest',
    'Rademar-Personalisation': getPersonalisationKey(),
  },
});

export default ajax;
